import React from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import { createStructuredSelector } from 'reselect';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from '@redux-saga/core';
import { wrapper } from '~/store';
import { loadProfile } from '~/containers/AuthProvider/actions';
import { USER_ROLES } from '~/config';
import { makeSelectCategories } from '~/containers/MetaDataProvider/selectors';
import categoryService from '~/services/categoryService';
import templateService from '~/services/templateService';
import metaDataService from '~/services/metaDataService';
import TemplatePreviewContent from '~/containers/TemplatePreviewContainer';
import LayoutEditorAC from '~/containers/DemoHomePageContainer/Layout';
import ModalPreviewTemplate from '~/components/ModalPreviewTemplate';
import withi18next from '~/hocs/withi18next';
import { loadMetaData } from '~/containers/MetaDataProvider/actions';
import { loadNewContent } from '~/containers/TemplatePageContainer/actions';
import SEOHead from '~/components/SharingMeta/SEOHead';
import cookies from '~/services/cookies';
import Breadcrumb from '~/components/Breadcrumb';
import withAutoLogin from '~/hocs/withAutoLogin';
import { redirectWithoutSSOToken } from '~/utils/mainHelpers/redirectWithoutSSOToken';

const mapDispatchToProps = (dispatch) => ({
  loadProfile: (profile) => dispatch(loadProfile(profile)),
  loadNewContent: (page, role) => dispatch(loadNewContent(page, role)),
});
const mapStateToProps = createStructuredSelector({
  categories: makeSelectCategories(),
});

@connect(mapStateToProps, mapDispatchToProps)
@withi18next()
@withAutoLogin()
class TemplatePreviewPage extends React.Component {
  state = {
    templatePreviewModalVisible: false,
    selectedTemplate: this.props.currentTemplate,
    dataSource: [],
  };

  setSelectedTemplate = (selectedTemplate) => {
    this.setState({ selectedTemplate });
  };

  handleOpenTemplatePreviewModal = (templatePreviewModalVisible) => {
    this.setState({ templatePreviewModalVisible });
  };

  componentDidMount() {
    const { loadProfile } = this.props;
    if (process.browser) {
      let userInfor = cookies.get('userInfo');
      if (userInfor) {
        userInfor = JSON.parse(userInfor);
      }
      const userProfile = {
        role: USER_ROLES.USER,
        subType: '',
        isAuthenticated: userInfor ? userInfor.isAuthenticated : false,
        userInfor: userInfor || null,
      };
      loadProfile(userProfile);

      if (userProfile.role === USER_ROLES.USER) {
        redirectWithoutSSOToken();
        // const currentURL = window.location.href;
        // if (currentURL.includes('?ssoToken')) {
        //   window.history.pushState(
        //     '',
        //     '',
        //     `${currentURL.split('?ssoToken')[0]}`,
        //   );
        // }
      }
    }
  }

  getCatNameByLang = () => {
    const { categories, catSlug, i18n, nameCat } = this.props;
    let currentLang = i18n.language;
    if (currentLang === 'ja') {
      currentLang = 'jp';
    }
    if (nameCat) return nameCat[`cat_name_${currentLang}`];

    let currentCategory = {};
    if (categories && catSlug) {
      let categoriesOfTemplate = categories.template;
      currentCategory = categoriesOfTemplate.filter((cat) => {
        return cat.cat_slug === catSlug;
      })[0];
    }

    if (currentCategory && currentCategory.name) {
      let nameLang = JSON.parse(currentCategory.name);
      return nameLang[`cat_name_${currentLang}`];
    }
    return '';
  };

  getTitleTemplate = () => {
    const { currentTemplate, t } = this.props;
    const { title } = currentTemplate;

    if (typeof title === 'string' && title) return title;

    return t('ace-breadcrumb-template', {
      categoryName: this.getCatNameByLang(),
      templateID: currentTemplate.id,
    });
  };

  render() {
    const {
      t,
      catSlug,
      templates,
      currentTemplate,
      currentTemplateTags,
      keywordsCat,
      i18n,
    } = this.props;
    const { templatePreviewModalVisible, selectedTemplate } = this.state;
    let currentLang = i18n.language;
    if (currentLang === 'ja') {
      currentLang = 'jp';
    }

    const catNameByLang = this.getCatNameByLang();
    const tempTitle = this.getTitleTemplate();
    const metaKeyword = keywordsCat
      ? keywordsCat[`cat_keywords_${currentLang}`]
      : '';

    return (
      <>
        <Head>
          <title>
            {t('ace-meta-templatepage-title', {
              template: tempTitle,
              category: catNameByLang,
              id: currentTemplate.id,
            })}
          </title>
          <meta
            name="description"
            content={t('ace-meta-templatepage-description', {
              template: tempTitle,
              category: catNameByLang,
              id: currentTemplate.id,
            })}
          />
          <meta name="keywords" content={metaKeyword} />
        </Head>
        <SEOHead
          path={`free-template/${catSlug}-template-${currentTemplate.id}`}
          lang={currentLang}
        />
        <LayoutEditorAC
          dataSource={this.props.templateNames}
          preventLoadMetaData
        >
          <div style={{ margin: '20px 0px' }}>
            <Breadcrumb
              style={{ marginBottom: 0, marginLeft: '30px' }}
              breadcrumbs={[
                { name: t('ace-breadcrumb-home'), href: '/' },
                {
                  name: t('ace-breadcrumb-template', {
                    categoryName: catNameByLang,
                    templateID: '',
                  }),
                  href: `/free-template/${catSlug}`,
                },
                {
                  name:
                    typeof currentTemplate.title === 'string' &&
                    currentTemplate.title
                      ? currentTemplate.title
                      : t('ace-breadcrumb-template', {
                          categoryName: catNameByLang,
                          templateID: currentTemplate.id,
                        }),
                },
              ]}
            />
            <TemplatePreviewContent
              isPage
              catNameByLang={catNameByLang}
              catSlug={catSlug}
              setSelectedTemplate={this.setSelectedTemplate}
              selectedTemplate={currentTemplate}
              currentTemplateTags={currentTemplateTags}
              templates={templates}
              handleOpenTemplatePreviewModal={
                this.handleOpenTemplatePreviewModal
              }
            />
            <div>
              <ModalPreviewTemplate
                isPage
                catNameByLang={catNameByLang}
                catSlug={catSlug}
                visible={templatePreviewModalVisible}
                handleOpenTemplatePreviewModal={
                  this.handleOpenTemplatePreviewModal
                }
                selectedTemplate={selectedTemplate}
                currentTemplate={currentTemplate}
                currentTemplateTags={currentTemplateTags}
                templates={templates}
                setSelectedTemplate={this.setSelectedTemplate}
              />
            </div>
          </div>
        </LayoutEditorAC>
      </>
    );
  }
}

export const getStaticPaths = async () => {
  // const { categories } = await metaDataService.getCategories({
  //     role: USER_ROLES.USER,
  //     lang: 'ja',
  // });
  // const lngs = ['ja', 'vi', 'en', 'ko', 'tw'];
  // const categoryTypes = categories.template.map((cat) => cat.cat_slug);
  const paths = [];
  // const pagesData = [];

  // await Promise.all(
  //     categoryTypes.map(async (type) => {
  //         const templateData = await templateService.listTemplates({
  //             page: 1,
  //             max_results: 10,
  //             role: USER_ROLES.USER,
  //             categorySlug: type,
  //             lang: 'ja',
  //         });
  //         templateData.templates.forEach((template) => {
  //             pagesData.push({
  //                 catSlug: type,
  //                 templateId: template.id,
  //             });
  //         });
  //     }),
  // );

  // pagesData.forEach((data) => {
  //     lngs.forEach((lng) => {
  //         paths.push({
  //             params: {
  //                 category_slug: data.catSlug,
  //                 template_id: data.templateId.toString(),
  //             },
  //             locale: lng,
  //         });
  //     });
  // });

  return { paths, fallback: 'blocking' };
};

export const getStaticProps = wrapper.getStaticProps(
  (store) => async ({ params, locale }) => {
    try {
      store.dispatch(loadMetaData());
      const { categories } = await metaDataService.getCategories({
        role: USER_ROLES.USER,
        lang: locale || 'ja',
      });
      let nameCat = '';
      let keywordsCat = '';
      let catSlug = params.category_slug;

      if (categories && categories.template) {
        let category = categories.template.filter((cat) => {
          return cat.cat_slug === catSlug;
        })[0];
        if (category) {
          nameCat = JSON.parse(category.name);
          keywordsCat = JSON.parse(category.keywords);
        }
      }

      const data = await templateService.listTemplates({
        page: 1,
        max_results: 100,
        role: USER_ROLES.USER,
        categorySlug: catSlug,
        lang: locale || 'ja',
      });
      const templates = data.templates.map((item) => {
        try {
          item.titles = JSON.parse(item.title);
          item.title = item.titles['title_original'] || '';
        } catch (err) {
          item.titles = item.title;
          item.title = '';
        }
        return {
          id: item.id,
          title: item.title,
          height: item.height,
          width: item.width,
          thumbnail_url: item.thumbnail_url,
          workarea_unit: item.workarea_unit,
          num_pages: item.num_pages,
          tags: item.tags,
          category: item.category,
          categories: item.categories,
        };
      });

      let templateID = params.template_id;
      let res = await templateService.loadTemplateDetail({
        templateID: templateID,
        role: USER_ROLES.USER,
      });
      if (res.template) {
        if (res.tags) {
          res.template.tags = res.tags;
        }
        try {
          res.template.titles = JSON.parse(res.template.title);
          res.template.title = res.template.titles['title_original'] || '';
        } catch (err) {
          res.template.titles = res.template.title;
          res.template.title = '';
        }
      }

      const categoryTemplatesRes = await categoryService.listTemplateCategories(
        {
          role: USER_ROLES.USER,
        },
      );
      let langTemplate = locale === 'ja' ? 'jp' : locale;
      const templateNames = categoryTemplatesRes.templates.map((cat) => ({
        id: cat.id,
        name: JSON.parse(cat.name)[`cat_name_${langTemplate}`],
      }));

      // If using async saga, end the saga
      store.dispatch(END);
      await store.sagaTask.toPromise();

      return {
        props: {
          ...(await serverSideTranslations(locale, ['common'])),
          catSlug,
          nameCat,
          keywordsCat: keywordsCat,
          templates,
          currentTemplate: {
            ...res.template,
            categories: res.categories || [],
            category: res.category,
          },
          currentTemplateTags: res.tags,
          templateNames,
        },
        revalidate: 60 * 60 * 24 * 7,
      };
    } catch (error) {
      return {
        notFound: true,
      };
    }
  },
);

export default TemplatePreviewPage;
